
<template>
<!-- 评论管理表 -->
  <div>
    <div style="margin-top: 15px;">
      <el-select v-model="searchBar.status" clearable placeholder="请选择状态" filterable style="margin-left: 30px;">
        <el-option label="已邀请" value="1"></el-option>
        <el-option label="已付款未下单" value="2"></el-option>
        <el-option label="已下单未付款" value="3"></el-option>
        <el-option label="已留评" value="5"></el-option>
        <el-option label="待留评" value="6"></el-option>
        <el-option label="无法留评" value="7"></el-option>
      </el-select>
      <el-input v-model="searchBar.asin" placeholder="请输入ASIN" style="width:150px;" clearable></el-input>
      <el-input v-model="searchBar.psku" placeholder="请输入内部SKU" style="width:150px;" clearable></el-input>
      <el-input v-model="searchBar.buyerName" placeholder="请输入客户姓名" style="width:150px;" clearable></el-input>
      <el-input v-model="searchBar.contactInformation" placeholder="请输入客户联系方式" style="width:180px;" clearable></el-input>
       <el-input v-model="searchBar.country" placeholder="请输入国家" style="width:150px;" clearable></el-input>
      <el-input v-model="searchBar.paypal" placeholder="请输入贝宝账号" style="width:180px;" clearable></el-input>
      <el-input placeholder="请输入跟踪进度" v-model="searchBar.processingProgress" class="input-with-select" style="width:200px;" clearable>
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="comments">
      <el-table :data="tableData" style="width: 100%" >
        <el-table-column label="创建时间" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.createTime |datefilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="ASIN" width="130px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.asin }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部SKU" width="130px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.psku }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.buyerName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户联系方式" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.contactInformation}}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟踪进度" width="180px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.processingProgress}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <!-- 修改： “跟进中”改为“待留评”；“未留评”改为“无法留评"；“已下单已付款”删掉。 -->
          <template slot-scope="scope">
            <span v-if="scope.row.status==1" style="margin-left: 10px">已邀请</span>
            <span v-if="scope.row.status==2" style="margin-left:10px">已付款未下单</span>
            <span v-if="scope.row.status==3" style="margin-left:10px">已下单未付款</span>
            <!-- <span v-if="scope.row.status==4" style="margin-left:10px">已下单已付款</span> -->
            <span v-if="scope.row.status==5" style="margin-left:10px">已留评</span>
            <span v-if="scope.row.status==6" style="margin-left:10px">待留评</span>
            <span v-if="scope.row.status==7" style="margin-left:10px">无法留评</span>
          </template>
        </el-table-column>
        <!-- 新增字段-->
        <el-table-column label="国家" width="120px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.country}}</span>
          </template>
        </el-table-column>
        <el-table-column label="资源获取人" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.resourceAcquirer}}</span>
          </template>
        </el-table-column>
        <el-table-column label="资源来源" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.resourcesFrom==1" style="margin-left: 10px">顾客投诉</span>
            <span v-if="scope.row.resourcesFrom==2" style="margin-left:10px">礼品卡</span>
            <span v-if="scope.row.resourcesFrom==3" style="margin-left:10px">明信片</span>
            <span v-if="scope.row.resourcesFrom==4" style="margin-left:10px">历史资源</span>
            <span v-if="scope.row.resourcesFrom==5" style="margin-left:10px">其他</span>
          </template>
        </el-table-column>
        <el-table-column label="客服邮箱" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.customerServiceEmail}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Paypal" width="120px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.paypal}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="250px">
          <template slot="header">
            <el-button type="primary" size="mini" @click="AddDialog">新增</el-button>
            <!-- 导入 -->
            <el-upload
                class="upload-demo"
                action="string"
                :limit="1"
                :before-upload="handleBeforeUpload"
                :http-request="husinessLicenseHandler"
                :show-file-list="false"
                ref="upload"
                :file-list="fileList">
              <el-button size="mini" type="success" :loading="uploadLoading">导入</el-button>
            </el-upload>
            <el-button type="warning" size="mini" @click="exportExcel()" :loading="downloadLoading">导出</el-button>
          </template>

          <template slot-scope="scope">
            <el-button size="mini"  @click="EditList(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
            <el-button size="mini" type="info" @click="cope(scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <div class="block" style="margin-top:20px;">
       <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
             layout="sizes,prev, pager, next,jumper"
            :total="total_elements"
            >
       </el-pagination>
      </div>
      <!-- 新增的对话框 -->
      <el-dialog title="评论管理表" :visible.sync="AddDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="100px" :model="addForm">
          <el-form-item label="ASIN">
            <el-input v-model="addForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="addForm.psku" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="addForm.buyerName"></el-input>
          </el-form-item>
          <!-- 修改：“客户邮箱”修改为“客户联系方式” -->
          <el-form-item label="客户联系方式">
            <el-input v-model="addForm.contactInformation"></el-input>
          </el-form-item>
          <el-form-item label="跟踪进度">
            <el-input v-model="addForm.processingProgress"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <!-- 修改： “跟进中”改为“待留评”；“未留评”改为“无法留评"；“已下单已付款”删掉。 -->
            <el-select v-model="addForm.status" placeholder="请选择">
              <el-option label="已邀请" value="1"></el-option>
              <el-option label="已付款未下单" value="2"></el-option>
              <el-option label="已下单未付款" value="3"></el-option>
              <el-option label="已留评" value="5"></el-option>
              <el-option label="待留评" value="6"></el-option>
              <el-option label="无法留评" value="7"></el-option>
            </el-select>
          </el-form-item>
          <!-- 新增字段 -->
          <el-form-item label="国家">
            <el-input v-model="addForm.country"></el-input>
          </el-form-item>
          <el-form-item label="资源获取人">
            <el-input v-model="addForm.resourceAcquirer"></el-input>
          </el-form-item>
          <el-form-item label="资源来源">
            <el-select v-model="addForm.resourcesFrom" placeholder="请选择">
              <el-option label="顾客投诉" value="1"></el-option>
              <el-option label="礼品卡" value="2"></el-option>
              <el-option label="明信片" value="3"></el-option>
              <el-option label="历史资源" value="4"></el-option>
              <el-option label="其他" value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- s数据来源接口 -->
          <el-form-item label="客服邮箱">
            <el-select v-model="addForm.customerServiceEmail" filterable placeholder="请选择">
               <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.supportEmail"
                :value="item.supportEmail">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="Paypal">
            <el-input v-model="addForm.paypal"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑的对话框 -->
      <el-dialog title="评论管理表" :visible.sync="editDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="100px" :model="editForm">
          <el-form-item label="id" style="display:none">
            <el-input v-model="editForm.id"></el-input>
          </el-form-item>
          <el-form-item label="ASIN">
            <el-input v-model="editForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="editForm.psku" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="editForm.buyerName"></el-input>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model="editForm.contactInformation"></el-input>
          </el-form-item>
          <el-form-item label="跟踪进度">
            <el-input v-model="editForm.processingProgress"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <!-- 修改： “跟进中”改为“待留评”；“未留评”改为“无法留评"；“已下单已付款”删掉。 -->
            <el-select v-model="editForm.status" placeholder="请选择">
              <el-option label="已邀请" value="1"></el-option>
              <el-option label="已付款未下单" value="2"></el-option>
              <el-option label="已下单未付款" value="3"></el-option>
              <el-option label="已留评" value="5"></el-option>
              <el-option label="待留评" value="6"></el-option>
              <el-option label="无法留评" value="7"></el-option>
            </el-select>
          </el-form-item>
          <!-- 新增字段 -->
          <el-form-item label="国家">
            <el-input v-model="editForm.country"></el-input>
          </el-form-item>
          <el-form-item label="资源获取人">
            <el-input v-model="editForm.resourceAcquirer"></el-input>
          </el-form-item>
          <el-form-item label="资源来源">
            <el-select v-model="editForm.resourcesFrom" placeholder="请选择">
              <el-option label="顾客投诉" value="1"></el-option>
              <el-option label="礼品卡" value="2"></el-option>
              <el-option label="明信片" value="3"></el-option>
              <el-option label="历史资源" value="4"></el-option>
              <el-option label="其他" value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- 数据来源接口 -->
          <el-form-item label="客服邮箱">
            <el-select v-model="editForm.customerServiceEmail" filterable placeholder="请选择">
               <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.supportEmail"
                :value="item.supportEmail">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="Paypal">
            <el-input v-model="editForm.paypal"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 复制的对话框 -->
      <el-dialog title="评论管理表" :visible.sync="copeDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="100px" :model="copeForm">
          <el-form-item label="id" style="display:none">
            <el-input v-model="copeForm.id"></el-input>
          </el-form-item>
          <el-form-item label="ASIN">
            <el-input v-model="copeForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="copeForm.psku" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="copeForm.buyerName"></el-input>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model="copeForm.contactInformation"></el-input>
          </el-form-item>
          <el-form-item label="跟踪进度">
            <el-input v-model="copeForm.processingProgress"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <!-- 修改： “跟进中”改为“待留评”；“未留评”改为“无法留评"；“已下单已付款”删掉。 -->
            <el-select v-model="copeForm.status" placeholder="请选择">
              <el-option label="已邀请" value="1"></el-option>
              <el-option label="已付款未下单" value="2"></el-option>
              <el-option label="已下单未付款" value="3"></el-option>
              <el-option label="已留评" value="5"></el-option>
              <el-option label="待留评" value="6"></el-option>
              <el-option label="无法留评" value="7"></el-option>
            </el-select>
          </el-form-item>
          <!-- 新增字段 -->
          <el-form-item label="国家">
            <el-input v-model="copeForm.country"></el-input>
          </el-form-item>
          <el-form-item label="资源获取人">
            <el-input v-model="copeForm.resourceAcquirer"></el-input>
          </el-form-item>
          <el-form-item label="资源来源">
            <el-select v-model="copeForm.resourcesFrom" placeholder="请选择">
              <el-option label="顾客投诉" value="1"></el-option>
              <el-option label="礼品卡" value="2"></el-option>
              <el-option label="明信片" value="3"></el-option>
              <el-option label="历史资源" value="4"></el-option>
              <el-option label="其他" value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- 数据来源接口 -->
          <el-form-item label="客服邮箱">
           <el-select v-model="copeForm.customerServiceEmail" filterable placeholder="请选择">
               <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.supportEmail"
                :value="item.supportEmail">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="Paypal">
            <el-input v-model="copeForm.paypal"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="copeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCope">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  apiAddReviewList,
  apiEditReviewList,
  apiDeleteReviewList,
  apiReviewSearch,
  apiCommentsExport,
  apiImportFile
} from "../../api/comments";
import {apiClientEmail} from "../../api/client";
export default {
  data() {
    return {
      //输入框
      searchBar:{
        status:'',
        asin:'',
        psku:'',
        buyerName:'',
        contactInformation:'',
        processingProgress:'',
        country:'',
        paypal:''
      },
      AddDialogVisible: false,
      editDialogVisible: false,
      uploadLoading: false,
      downloadLoading: false,
      labelPosition: "right",
      //新增表单数据：
      addForm: {},
      //编辑表单数据：
      editForm: {},
      //表格绑定数据
      //分页器数据
      currentPage: 1, //默认第一页 当前页
      size: 10,
      total_elements:0,//总条数
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      id: "",
      // 复制数据
      copeDialogVisible:false,
      copeForm:{},
      options:[],//客服邮箱初始数据
      fileList:[],//客服邮箱初始数据
    };
  },
  methods: {
   handleSizeChange(size) {
      this.size = size;
      this.search(false);
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.search(false);
    },
    // 删除
    handleDelete(id) {
      // 提示用户是否删除
       this.$confirm('是否要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDeleteReviewList(id).then((res) => {
            if (res.data.code === 200) {
              this.search(false);
              this.$message.success(res.data.message);
            }else{
              this.$message(res.data.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    // 搜索
    search(boolean){
      this.searchBar = this.common.clearNull(this.searchBar);
      this.currentPage = boolean ? 1 : this.currentPage;
        apiReviewSearch({
          page: this.currentPage,
          size: this.size,
          q: JSON.stringify(this.searchBar),
          sort: "id",
          direction: "DESC",
        }).then((res) => {
          if (res.data.code === 200) {
            if (boolean) {
              this.$message.success(res.data.message);
            }
            this.tableData = res.data.data.content;
            this.total_elements = res.data.data.totalElements;
          }else{
            this.$message.error(res.data.message)
          }
        });

    },
    // 获取全部数据
    // getReviewList() {
    //   apireviewList({
    //     page: this.currentPage,
    //     size: this.size,
    //   }).then((res) => {
    //     if (res.data.code === 200) {
    //       this.tableData = res.data.data.content;
    //       this.total_elements = res.data.data.total_elements;
    //     }
    //   });
    // },
    // 点击新增
    AddDialog(){
      this.AddDialogVisible = true;
      this.getEmail();
    },
    //点击确定按钮新增数据
    submitAdd() {
      apiAddReviewList(this.addForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.AddDialogVisible = false;
          this.addForm = {};
          this.search(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    //点击编辑回传数据
    //修改表单数据 双向修改改成深拷贝
    EditList(data) {
      this.editDialogVisible = true;
      this.editForm = JSON.parse(JSON.stringify(data));
      this.getEmail();
    },
    // 复制
    cope(data){
      this.copeDialogVisible = true;
      this.copeForm = JSON.parse(JSON.stringify(data));    
    },
    // 点击确认复制按钮(要新添加数据)
    submitCope(){
      apiAddReviewList(this.copeForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.copeDialogVisible = false;
          this.copeForm = {};
          this.search(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    //点击编辑按钮修改数据
    submitEdit() {
      apiEditReviewList({
        id: this.editForm.id,
        data: this.editForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.editDialogVisible = false;
          this.editForm = {};
          this.search(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    //导入
    handleBeforeUpload(file) {//上传文件之前的钩子，参数为上传的文件
      if (file.name.indexOf("xls") === -1 && file.name.indexOf("xlsx") === -1) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return false;
      }
    },
    // 成功
    husinessLicenseHandler(params){//覆盖
      this.uploadLoading = true;
      const _file = params.file;
      var formData = new FormData()// 通过 FormData 对象上传文件
      formData.append('file', _file)
      apiImportFile(formData).then((res)=>{
        if(res.data.code == 200){
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          this.search(true);
        }else{
          this.$message.error('导入失败');
        }
      }).finally(() => {
        this.fileList = [];
        this.uploadLoading = false;
      })
    },
    // checkbox
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    // 导出
    exportExcel(){
     this.downloadLoading = true;
        var filename = '评论管理.xlsx'
        apiCommentsExport({q:JSON.stringify(this.searchBar)}).then((res)=>{
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
          let objectUrl = URL.createObjectURL(blob) // 创建URL
          link.href = objectUrl
          link.download = filename
          link.click()
          link.remove()
          URL.revokeObjectURL(objectUrl);
          // this.search();
        }).finally(() => {
          this.downloadLoading = false;
        })

    },
    // 获取客服邮箱
    getEmail(){
      apiClientEmail().then((res=>{
        if(res.data.code == 200){
          this.options = res.data.data
        }
      }))
    },
    //  多条件搜索
    // getSearchDate(){
    //   apiReviewSearch({
    //     page: this.currentPage,
    //     size: this.size,
    //     data: this.searchBar
    //   }).then((res) => {
    //     if (res.data.code === 200) {
    //       this.tableData = res.data.data.content;
    //       this.total_elements = res.data.data.total_elements;
    //     }else{
    //       this.$message.error(res.data.message)
    //     }
    //   });
    // }
  },

  created() {
    //一点进来就获取用户列表
    this.search(true);
  },

  //日期的格式化
  filters: {
    datefilter: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
      //这里的日期格式可自定义
    },
  },
};
</script>

<style lang='less' scoped>
.el-input-group {
  // margin-left: 30px;
  width: 500px;
}

.comments {
  padding: 50px 30px;
  .el-pagicountry {
    padding: 32px 0px;
  }
}
.el-select>.el-input {
    width: 80% !important;
}
</style>